import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createAppStore, getPersistor, ApiUrls } from '@ideoz/core';
import { default as apiClient } from '@ideoz/core/api/client';
import { initAnalytics } from '@ideoz/core/analytics';
import App from './App';
import './index.scss';
import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string;

try {
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    track_pageview: true,
    record_sessions_percent: 100,
    record_heatmap_data: true,
    record_mask_all_text: false,
    ignore_dnt: true,
  });
} catch (e) {
  console.warn('Mixpanel initialization failed:', e);
}

// Create Redux store
const store = createAppStore();
const persistor = getPersistor(store);

// Initialize analytics service
initAnalytics(apiClient, ApiUrls.events, () => store.getState() as any);

const rootElement = document.getElementById('root');

if (rootElement) {
  // Store the root instance on the element to persist across HMR updates
  if (!(rootElement as any)._reactRoot) {
    (rootElement as any)._reactRoot = ReactDOM.createRoot(rootElement);
  }
  (rootElement as any)._reactRoot.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}
